import React, { useState } from "react"
import { theme, device } from "./Theme"
import styled from "@emotion/styled/macro"
import SvgPhoneMobile from "../images/SVGs/PhoneMobile"
import { Link } from "gatsby"
import { HeaderTextBottom } from "./HeaderTextBottom"
import { GatsbyImage } from "gatsby-plugin-image"
import { NavMobile } from "./NavMobile"
import { CustomModal } from "./CustomModal"
import { Form } from "./Form"

const HeaderMobile = props => {
  const HeaderMobileContainer = styled.div`
    position: relative;
    @media ${device.lg} {
      display: none;
    }
    .buttonContainer {
      background-color: #550000;
      box-sizing: border-box;
      padding: 10px 0;
    }
    .topButton {
      appearance: none;
      border: none;
      background-color: ${theme.colors.secondary};
      color: ${theme.colors.dark};
      letter-spacing: 2px;
      font-family: ${theme.fonts.altFont};
      font-weight: 700;
      font-size: 1rem;
      display: block;
      width: 100%;
      max-width: 250px;
      margin: 0 auto;
      text-transform: uppercase;
      padding: 1.25rem;
      text-align: center;

      &:hover,
      &:active {
        cursor: pointer;
        color: ${theme.colors.primary};
      }
    }
    .middleSection {
      padding: 0.5rem 1.25rem;
      display: grid;
      grid-template-columns: 1fr 2fr 1fr;
      align-items: center;
      grid-column-gap: 1.25rem;
    }

    .gatsbyImageContainerNoTransition {
      .gatsby-image-wrapper [data-main-image] {
        transition: none;
        pointer-events: none;
      }
    }
    .centerImage {
      display: flex;
      justify-content: center;
    }
    .hoverSvg {
      svg {
        transition: transform 0.2s ease-in;
      }

      &:hover,
      &:active {
        svg {
          transform: rotate(25deg);
          circle {
            fill: ${theme.colors.secondary};
          }
        }
      }
    }
  `
  const [sidebar, setSidebar] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  return (
    <HeaderMobileContainer>
      <HeaderTextBottom headerData={props.headerData} />

      <div className="middleSection">
        <NavMobile
          mainMenuItems={props.mainMenuItems}
          headerData={props.headerData}
          sidebarOpen={sidebar}
          formData={props.formData}
          buttonText={props.buttonText.buttonText}
        />
        <Link to="/" className="gatsbyImageContainerNoTransition centerImage">
          <GatsbyImage image={props.headerData.logo} alt="logo" />
        </Link>

        <a
          className="centerImage hoverSvg"
          href={`tel:` + props.headerData.phoneNumber}
        >
          <SvgPhoneMobile />
        </a>
      </div>
      <div className="buttonContainer">
        <button className="topButton" onClick={() => setIsModalOpen(true)}>
          {props.buttonText.buttonText}
        </button>
      </div>
      <CustomModal
        onClose={() => setIsModalOpen(false)}
        isModalOpen={isModalOpen}
        modalContent={<Form data={props.formData} />}
      />
    </HeaderMobileContainer>
  )
}
export { HeaderMobile }
